import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  FiChevronLeft,
  FiChevronRight,
  FiSave,
  FiX,
  FiPlus,
  FiEdit,
  FiSearch,
} from 'react-icons/fi';
import { toast } from 'react-toastify';
// import * as Yup from 'yup';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useDispatch } from 'react-redux';

import TextArea from 'components/TextArea';
import Button from 'components/Button';
import Spinner from 'components/Spinner';
import ReactDropzoneInput from 'components/DropZone';
import Select from 'components/Select';
import Input from 'components/Input';
import Checkbox from 'components/Checkbox';
import Radio from 'components/Radio';

import api from 'services/api';
import AppError from 'utils/AppError';
// import getValidationErrors from 'services/getValidationErros';

import { show } from 'store/modules/dialog/actions';

import {
  FormGroups,
  ImagemItem,
  ImagensContainer,
  StepSection,
  OptionCard,
  OptionalContent,
  VoiceGrid,
  TextGrid,
  Actions,
  ActionsLeft,
  ActionsCenter,
  ActionsRight,
  StepHeader,
  ScrollContent,
  ScrollArea,
  StepSectionsRow,
  CallToActionFields,
  FalasGrid,
  // LocucaoContent,
  OptionCardActions,
  OptionCardHeader,
  ModalContent,
  Overlay,
  ModalContainer,
  ModalFooter,
} from './styles';
import { Criativo as CriativoItem } from 'pages/@types';
import EditableField from 'components/EditableField';
import { createPortal } from 'react-dom';
import { StatusCriativo } from 'utils/variables';

interface CriativoStoreProps {
  // onClose: () => void;
  selectedId: number;
  // initialData?: Record<string, any>;
  setShowCriativoModal: React.Dispatch<React.SetStateAction<boolean>>;
  setCriativos: React.Dispatch<React.SetStateAction<CriativoItem[]>>;
  idsPendentesRef: React.MutableRefObject<number[]>;
  tipoFormulario: 'normal' | 'site';
}
interface TextoCriativo {
  estilo?: string;
  momento?: string;
  posicao?: string;
  conteudo?: string;
  texto?: string;
}
interface OpcaoSelect {
  value: string;
  label: string;
}
interface Categorias {
  rotulo?: string;
  segmentos?: Record<string, string>;
}
interface Objetivos {
  rotulo?: string;
  cta_padrao?: string;
  ctas?: string[];
}
interface Catalogos {
  categorias: Record<string, Categorias>;
  objetivos: Record<string, Objetivos>;
}
interface DadosCriativo {
  nomeproduto?: string;
  duracao?: string;
  tipo?: string;
  categorias?: string;
  segmentos?: string;
  catalogos?: string;
  objetivos?: string;
  estilo_0?: string;
  conteudo_0?: string;
  // estilo_1?: string;
  conteudo_1?: string;
  locucaotexto_0?: string;
  locucaotexto_1?: string;
  locucaotexto_2?: string;
  detalhes_en?: string;
  criativotextos?: TextoCriativo[];
  [campo: string]: unknown;
}

const CAMPOS_DO_REGISTRO = [
  'id',
  'job_id',
  'status',
  'finish_at',
  'created_at',
  'updated_at',
  'solicitante',
  'criativomidias',
  'criativotextos',
  'downloaded_at',
  'download_url',
  'filename',
];

// Um select pode entregar:
// { value: 'institucional', label: 'INSTITUCIONAL' }
// Mas a API espera apenas:
// 'institucional'
function valorDoSelect(value: any) {
  return value && typeof value === 'object' && 'value' in value
    ? value.value
    : value;
}

function textoOriginal(data: DadosCriativo, tipo: 'cta' | 'extra') {
  const textosPersistidos = Array.isArray(data.criativotextos)
    ? data.criativotextos
    : [];
  const textoCTA = textosPersistidos.find(
    (texto: any) => String(texto?.momento ?? '').toLowerCase() === 'final',
  );
  const textoExtra =
    textosPersistidos.find(
      (texto: any) => String(texto?.momento ?? '').toLowerCase() !== 'final',
    ) ?? (textoCTA ? undefined : textosPersistidos[0]);

  return tipo === 'cta' ? textoCTA : textoExtra;
}

function refinarCriativoDados(initialData: DadosCriativo) {
  const textoExtra = textoOriginal(initialData, 'extra');
  const textoCTA = textoOriginal(initialData, 'cta');

  const habilitarTextos = Boolean(
    initialData.habilitarTextos ||
      initialData.conteudo_0 ||
      textoExtra?.conteudo ||
      textoExtra?.texto ||
      textoExtra?.estilo ||
      textoExtra?.momento ||
      textoExtra?.posicao,
  );
  const habilitarLocucao = Boolean(
    initialData.habilitarLocucao ||
      initialData.locucaogenero ||
      initialData.locucaoidade ||
      initialData.locucaotom ||
      initialData.locucaotexto_0,
  );

  return {
    ...initialData,
    tipo: initialData.tipo ?? '',
    estilo_0: initialData.estilo_0 || textoExtra?.estilo || '',
    momento_0: initialData.momento_0 || textoExtra?.momento || '',
    posicao_0: initialData.posicao_0 || textoExtra?.posicao || '',
    conteudo_0:
      initialData.conteudo_0 || textoExtra?.conteudo || textoExtra?.texto || '',
    // estilo_1: initialData.estilo_1 || textoCTA?.estilo || '',
    momento_1: initialData.momento_1 || textoCTA?.momento || 'final',
    posicao_1: initialData.posicao_1 || textoCTA?.posicao || 'rodape',
    conteudo_1:
      initialData.conteudo_1 || textoCTA?.conteudo || textoCTA?.texto || '',
    duracao: initialData.duracao ? String(initialData.duracao) : '',
    categorias: initialData.categorias ?? initialData.catalogos,
    habilitarLocucao,
    habilitarTextos,
  };
}

function quantidadeDeFalas(data: DadosCriativo) {
  const ultimaFala = [0, 1, 2]
    .filter(index => Boolean(data[`locucaotexto_${index}`]))
    .pop();

  return ultimaFala === undefined ? 1 : ultimaFala + 1;
}

// criarPayload transforma os dados da tela em FormData
// formato necessário para enviar campos e arquivos no mesmo POST
function criarPayload(data: DadosCriativo) {
  const payload = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    //Ignora flags usadas apenas pela interface:
    if (['habilitarLocucao', 'habilitarTextos'].includes(key)) return;

    // trata uploads
    if (key.startsWith('file_')) {
      (Array.isArray(value) ? value : []).forEach(file => {
        if (file instanceof Blob) payload.append('files', file);
      });
      return;
    }
    // restante dos valores, quais não são os anteriores ^
    if (value !== undefined && value !== null) {
      const valor = valorDoSelect(value);

      if (key === 'site' && !String(valor).trim()) {
        return;
      }

      payload.append(key, String(valor));
    }
  });

  return payload;
}

// Schema de validação do formulário.
// const schema = Yup.object().shape({
//   // Informações principais
//   nomeproduto: Yup.string()
//     .trim()
//     .required('Campo Obrigatório')
//     .max(45, 'Título excedeu o limite de 45 caracteres'),

//   duracao: Yup.string()
//     .required('Selecione a duração do criativo')
//     .nullable(),
//   tipo: Yup.string().required('Selecione o modelo do criativo'),
//   categorias: Yup.string().required('Selecione a categorias do negócio'),
//   objetivos: Yup.string().required('Selecione o objetivo do criativo'),
//   segmentos: Yup.string().required('Selecione o segmento do criativo'),

//   // Logo obrigatória no novo criativo.
//   // No refinamento, a logo original já pertence ao criativo de origem.
//   file_0: Yup.mixed().test('logo-obrigatoria', 'A logo é obrigatória', function(
//     value,
//   ) {
//     const context = this.options.context as
//       | { modoRefinamento?: boolean }
//       | undefined;

//     if (context?.modoRefinamento) return true;

//     if (Array.isArray(value)) return value.length > 0;
//     return Boolean(value);
//   }),

//   // Locução: os campos só são obrigatórios quando a opção estiver habilitada.
//   locucaogenero: Yup.string().when('habilitarLocucao', {
//     is: true,
//     then: Yup.string().required('Selecione o gênero da locução'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   locucaoidade: Yup.string().when('habilitarLocucao', {
//     is: true,
//     then: Yup.string().required('Selecione a idade da locução'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   locucaotom: Yup.string().when('habilitarLocucao', {
//     is: true,
//     then: Yup.string().required('Selecione o tom da locução'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   locucaotexto_0: Yup.string().when('habilitarLocucao', {
//     is: true,
//     then: Yup.string()
//       .trim()
//       .required('Informe a primeira fala'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   // Falas adicionais são opcionais.
//   locucaotexto_1: Yup.string().notRequired(),
//   locucaotexto_2: Yup.string().notRequired(),

//   // Texto extra durante o vídeo: obrigatório somente quando habilitado.
//   estilo_0: Yup.string().when('habilitarTextos', {
//     is: true,
//     then: Yup.string().required('Selecione o estilo do texto extra'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   momento_0: Yup.string().when('habilitarTextos', {
//     is: true,
//     then: Yup.string().required('Selecione o momento do texto extra'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   posicao_0: Yup.string().when('habilitarTextos', {
//     is: true,
//     then: Yup.string().required('Selecione a posição do texto extra'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   conteudo_0: Yup.string().when('habilitarTextos', {
//     is: true,
//     then: Yup.string()
//       .trim()
//       .required('Informe o conteúdo do texto extra'),
//     otherwise: Yup.string().notRequired(),
//   }),

//   // Call to action: campos apresentados no formulário.
// estilo_1: Yup.string().when('$modoRefinamento', {
//   is: true,
//   then: Yup.string().notRequired(),
//   otherwise: Yup.string().required(
//     'Selecione o estilo do call to action',
//   ),
// }),

// conteudo_1: Yup.string().when('$modoRefinamento', {
//   is: true,
//   then: Yup.string().notRequired(),
//   otherwise: Yup.string()
//     .trim()
//     .required('Informe o texto do call to action'),
// }),

//   // Não validar os próprios controles opcionais nem os grupos de imagens opcionais:
//   // habilitarLocucao, habilitarTextos, file_1, file_2, file_3,
//   // tipo_1, tipo_2, tipo_3.
// });
interface ICriativoMidia {
  id: number;
  filename: string | null;
  tipo: string | null;
  download_url: string | null;
}

export default function CriativoStore({
  setCriativos,
  selectedId,
  setShowCriativoModal,
  idsPendentesRef,
  tipoFormulario,
}: CriativoStoreProps) {
  const [loading, setLoading] = useState(selectedId ? true : false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingURL, setLoadingURL] = useState(false);

  const [step, setStep] = useState(1);
  const [mostrarLocucao, setMostrarLocucao] = useState(false);
  const [mostrarTextos, setMostrarTextos] = useState(false);
  const [tipoSelecionado, setTipoSelecionado] = useState('');
  const [editingFields, setEditingFields] = useState<string[]>([]);
  const [quantidadeFalas, setQuantidadeFalas] = useState(1);
  const [initialData, setInitialData] = useState<Record<string, any>>({});
  const [midias, setMidias] = useState<ICriativoMidia[]>([]);

  const [criativoId, setCriativoId] = useState<number | null>(null);

  const modoRefinamento = selectedId > 0;
  const [options, setOptions] = useState<any>(null);
  const [catalogos, setCatalogos] = useState<Catalogos>({
    categorias: {},
    objetivos: {},
  });
  const [objetivos, setObjetivos] = useState<OpcaoSelect[]>([]);
  const [segmentos, setSegmentos] = useState<OpcaoSelect[]>([]);
  const categoriasOptions: OpcaoSelect[] = Object.entries(
    catalogos.categorias ?? {},
  ).map(([value, categoria]) => ({
    value,
    label: categoria.rotulo ?? value,
  }));
  const dispatch = useDispatch();

  const formRef = useRef<FormHandles>(null);
  const formDataRef = useRef<Record<string, any>>({});
  const formRefSite = useRef<FormHandles>(null);

  const categorias =
    catalogos.categorias?.[String(formDataRef.current.categorias ?? '')];
  const segmento =
    categorias?.segmentos?.[String(formDataRef.current.segmentos ?? '')];
  const objetivo =
    catalogos.objetivos?.[String(formDataRef.current.objetivos ?? '')];

  const updateFormField = useCallback((field: string, value: any) => {
    formDataRef.current = {
      ...formDataRef.current,
      [field]: valorDoSelect(value),
    };
  }, []);

  const adicionarFala = useCallback(() => {
    setQuantidadeFalas(quantidadeAtual => Math.min(3, quantidadeAtual + 1));
  }, []);

  const removerFala = useCallback(
    (indexRemover: number) => {
      if (quantidadeFalas <= 1) return;
      const dadosAtuais = {
        ...formDataRef.current,
        ...(formRef.current?.getData?.() || {}),
      };
      // Reorganiza as falas após a remoção.
      for (let index = indexRemover; index < quantidadeFalas - 1; index++) {
        const campo = `locucaotexto_${index}`;
        const proximoCampo = `locucaotexto_${index + 1}`;
        const valor = dadosAtuais[proximoCampo] ?? '';
        formDataRef.current[campo] = valor;
        formRef.current?.setFieldValue(campo, valor);
      }
      // Limpa o último campo.
      const ultimoCampo = `locucaotexto_${quantidadeFalas - 1}`;
      formDataRef.current[ultimoCampo] = '';
      formRef.current?.setFieldValue(ultimoCampo, '');

      setEditingFields(current =>
        current.filter(field => !/^locucaotexto_[0-2]$/.test(field)),
      );
      setQuantidadeFalas(atual => Math.max(1, atual - 1));
    },
    [quantidadeFalas],
  );

  // Guarda dados dos steps anteriores.
  // Usamos uma chave estável para não rehidratar o formulário toda vez
  // que o objeto initialData for recriado pelo componente pai.
  const initialDataKey =
    initialData?.criativo_origem_id ?? initialData?.id ?? 'novo';

  useEffect(() => {
    const dadosIniciais = refinarCriativoDados(initialData);

    setQuantidadeFalas(quantidadeDeFalas(dadosIniciais));
    setTipoSelecionado(dadosIniciais.tipo);
    setMostrarLocucao(dadosIniciais.habilitarLocucao);
    setMostrarTextos(dadosIniciais.habilitarTextos);
    setEditingFields([]);
    formDataRef.current = dadosIniciais;
    formRef.current?.setData(formDataRef.current);
    // forceFormRender(version => version + 1);
    setStep(initialData?.criativo_origem_id ? 4 : 1);
  }, [initialData, initialDataKey]);

  useEffect(() => {
    const loadOptions = async () => {
      try {
        const response = await api.get('/criativos/options');
        const { options: data, catalogo } = response.data;
        if (data) {
          const options = (data?: Record<string, string> | null) =>
            Object.entries(data ?? {}).map(([value, label]) => ({
              value,
              label: String(label),
            }));
          const optionsLocucao = (data: string[]) =>
            data.map(value => ({
              value,
              label: value
                .replace(/-/g, ' ')
                .replace(/\b\w/g, char => char.toUpperCase()),
            }));
          setOptions({
            tipo: Object.entries(data.tipo).map(([value, label]) => ({
              value,
              label,
            })),
            tipo_loja: options(data.tipo_loja),
            ritmo: options(data.ritmo),
            estilo: options(data.estilo),
            iluminacao: options(data.iluminacao),
            musica: options(data.musica),
            camera: options(data.camera),
            cenario: options(data.cenario),
            abertura: options(data.abertura),
            acao: options(data.acao),
            movimento_loja: options(data.movimento_loja),
            imagens: options(data['imagens (papéis)']).filter(
              option => option.value !== 'logo',
            ),
            textos: {
              estilo: options(data.textos.estilo),
              momento: options(data.textos.momento),
              posicao: options(data.textos.posicao),
            },
            locucao: {
              locucaogenero: optionsLocucao(data.locucao.genero),
              locucaoidade: optionsLocucao(data.locucao.idade),
              locucaoidioma: optionsLocucao(data.locucao.idioma),
              locucaotom: optionsLocucao(data.locucao.tom),
            },
          });
        }
        if (catalogo?.categorias) {
          const catalogoRecebido = catalogo as Catalogos;
          setCatalogos(catalogoRecebido);
          setObjetivos(
            Object.entries(catalogoRecebido.objetivos ?? {}).map(
              ([value, objetivo]) => ({
                value,
                label: objetivo.rotulo ?? value,
              }),
            ),
          );
        }
      } catch (error) {
        console.error('Erro ao carregar opções:', error);
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          toast.error('Erro ao carregar opções');
        }
      }
    };
    loadOptions();
  }, []);

  // Por eu estar querendo que o card fique por cima de tudo, os selects ficavam por baixo, isso faz com que apareçam no lugar correto REVISAR!!!
  const selectMenuProps = useMemo(
    () => ({
      menuPortalTarget: document.body,
      styles: {
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 100001,
        }),
      },
    }),
    [],
  );

  const handleSubmit = useCallback(
    async (criativo: Record<string, any>) => {
      try {
        if (!formRef.current) {
          return;
        }

        setLoadingSubmit(true);
        formRef.current.setErrors({});

        // Fluxo original de criação/refinamento
        const dadosDoFormulario: DadosCriativo = {
          ...formDataRef.current,
          ...criativo,
          tipo: tipoSelecionado || criativo.tipo || formDataRef.current.tipo,
          habilitarLocucao: mostrarLocucao,
          habilitarTextos: mostrarTextos,
        };

        const dadosCompletos: Record<string, any> = {
          ...dadosDoFormulario,
          ...(modoRefinamento
            ? {
                criativo_origem_id:
                  initialData.criativo_origem_id ??
                  initialData.id ??
                  selectedId,
              }
            : {}),
          tipo_0: 'logo',
          momento_1: 'final',
          posicao_1: 'rodape',
        };

        CAMPOS_DO_REGISTRO.forEach(campo => {
          delete dadosCompletos[campo];
        });

        const formData = criarPayload(dadosCompletos);

        const response = criativoId
          ? await api.patch(`/criativos/${criativoId}`, formData)
          : await api.post('/criativos', formData);

        if (response?.data) {
          const novoCriativo: CriativoItem = response.data;

          setCriativos(prev => [novoCriativo, ...prev]);

          idsPendentesRef.current = [
            ...idsPendentesRef.current,
            novoCriativo.id,
          ];

          setShowCriativoModal(false);

          dispatch(
            show({
              type: 'success',
              contentHTML:
                '<h3>Criativo solicitado com sucesso!</h3><p>O criativo foi enviado para processamento.',
              timer: 3000,
              showCancelButton: false,
              showConfirmButton: false,
              showCloseButton: true,
            }),
          );

          return;
        }

        toast.error('Falha ao criar Criativo');
      } catch (err) {
        if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
      } finally {
        setLoadingSubmit(false);
      }
    },
    [
      tipoSelecionado,
      mostrarLocucao,
      mostrarTextos,
      modoRefinamento,
      initialData.criativo_origem_id,
      initialData.id,
      selectedId,
      setCriativos,
      idsPendentesRef,
      setShowCriativoModal,
      dispatch,
      criativoId,
    ],
  );

  const handleMessage = useCallback(
    ({ contentHTML, redirectTo, type }) => {
      dispatch(
        show({
          type,
          confirmButtonText: '',
          contentHTML,
          timer: 3000,
          cancelButtonText: 'NÃO',
          redirectTo,
          showCancelButton: false,
          showConfirmButton: false,
          showCloseButton: true,
        }),
      );
    },
    [dispatch],
  );

  const handleSubmitSite = useCallback(
    async (criativo: CriativoItem) => {
      formRefSite.current?.setErrors({});

      const site = criativo.site?.trim();

      if (!site) {
        toast.error('Informe o site antes de buscar.');
        return;
      }

      // Fecha a modal imediatamente.
      setShowCriativoModal(false);

      // Exibe a mensagem imediatamente.
      handleMessage({
        contentHTML:
          '<h3>Solicitação enviada!</h3><p>Estamos analisando o site do seu cliente. Aguarde.</p>',
        redirectTo: '/criativos',
        type: 'success',
      });

      // A requisição continua sem bloquear a interface.
      void api
        .post('/criativos', {
          site,
          nomeproduto: criativo.nomeproduto,
          duracao: criativo.duracao,
          status: StatusCriativo.RASCUNHO,
        })
        .then(({ data }) => {
          setCriativos(prev => [
            data,
            ...prev.filter(item => item.id !== data.id),
          ]);

          idsPendentesRef.current = [
            ...new Set([...idsPendentesRef.current, data.id]),
          ];
        })
        .catch(() => {
          toast.error('Erro ao criar o rascunho no servidor.');
        });
    },
    [handleMessage, setCriativos, idsPendentesRef, setShowCriativoModal],
  );

  const changeStep = (newStep: number) => {
    const formAtual = formRef.current?.getData?.() || {};
    const dadosDoFormulario: DadosCriativo = {
      ...formDataRef.current,
      ...formAtual,
      tipo: tipoSelecionado || formAtual.tipo || formDataRef.current.tipo,
      habilitarLocucao: mostrarLocucao,
      habilitarTextos: mostrarTextos,
      ...(initialData?.criativo_origem_id
        ? { criativo_origem_id: initialData.criativo_origem_id }
        : {}),
    };

    formDataRef.current = dadosDoFormulario;
    formRef.current?.setErrors({});
    setStep(newStep);
  };

  // puxar no select segmento da categorias correspondente
  const handleCategoriaChange = useCallback(
    (categoria: OpcaoSelect) => {
      const categoriaValue = categoria?.value ?? '';
      if (!catalogos.categorias) {
        return;
      }
      const categoriaSelecionada = catalogos.categorias[categoriaValue];

      const novosSegmentos: OpcaoSelect[] = Object.entries(
        categoriaSelecionada?.segmentos ?? {},
      ).map(([value, label]) => ({
        value,
        label,
      }));

      setSegmentos(novosSegmentos);

      const segmentoAtual = formDataRef.current.segmentos;

      if (
        segmentoAtual &&
        !novosSegmentos.some(item => item.value === segmentoAtual)
      ) {
        updateFormField('segmentos', '');
        formRef.current?.setFieldValue('segmentos', '');
      }
    },
    [catalogos, updateFormField],
  );

  useEffect(() => {
    const controller = new AbortController();
    async function loadCriativo() {
      if (!selectedId) {
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const response = await api.get(`/criativos/${selectedId}`, {
          signal: controller.signal,
        });
        console.log(response.data);
        const criativo = response.data;
        const textos = criativo.criativotextos ?? [];
        const textoCTA = textos.find(
          (texto: any) =>
            String(texto?.momento ?? '').toLowerCase() === 'final',
        );
        const textoExtra =
          textos.find(
            (texto: any) =>
              String(texto?.momento ?? '').toLowerCase() !== 'final',
          ) ?? (textoCTA ? undefined : textos[0]);

        let falas: string[] = [];

        if (Array.isArray(criativo.falas)) {
          falas = criativo.falas;
        } else if (
          typeof criativo.falas === 'string' &&
          criativo.falas.trim() !== ''
        ) {
          try {
            const parsed = JSON.parse(criativo.falas);

            if (Array.isArray(parsed)) {
              falas = parsed;
            }
          } catch (error) {
            console.error('Erro ao interpretar falas:', error);
          }
        }
        setInitialData({
          ...criativo,
          // TEXTO EXTRA
          estilo_0: criativo.estilo_0 || textoExtra?.estilo || '',
          momento_0: criativo.momento_0 || textoExtra?.momento || '',
          posicao_0: criativo.posicao_0 || textoExtra?.posicao || '',
          conteudo_0:
            criativo.conteudo_0 ||
            textoExtra?.conteudo ||
            textoExtra?.texto ||
            '',
          // TEXTO CTA
          momento_1: criativo.momento_1 || textoCTA?.momento || 'final',
          posicao_1: criativo.posicao_1 || textoCTA?.posicao || 'rodape',
          conteudo_1:
            criativo.conteudo_1 || textoCTA?.conteudo || textoCTA?.texto || '',
          // LOCUÇÃO
          locucaotexto_0: falas[0] ?? '',
          locucaotexto_1: falas[1] ?? '',
          locucaotexto_2: falas[2] ?? '',
        });
      } catch (e) {
        if (controller.signal.aborted) return;
        if (e instanceof AppError || e instanceof Error) {
          toast.error(e.message);
        } else {
          toast.error('Erro inesperado');
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    }
    loadCriativo();
    return () => {
      controller.abort();
    };
  }, [criativoId, selectedId, setShowCriativoModal]);

  // carrega os segmentos das categorias correspondentes
  useEffect(() => {
    const categoriaValue = String(
      initialData?.categorias ?? initialData?.catalogos ?? '',
    );

    if (!categoriaValue || !catalogos.categorias) {
      setSegmentos([]);
      return;
    }

    const categoriaSelecionada = catalogos.categorias[categoriaValue];

    const novosSegmentos: OpcaoSelect[] = Object.entries(
      categoriaSelecionada?.segmentos ?? {},
    ).map(([value, label]) => ({
      value,
      label,
    }));

    setSegmentos(novosSegmentos);
  }, [catalogos, initialData]);

  // STEPS
  function renderStep1() {
    return (
      <div>
        <StepSection>
          <div>
            <header>
              <h5>INFORMAÇÕES BÁSICAS</h5>
              <p>Defina o nome e a duração do seu criativo.</p>
            </header>
          </div>
          <FormGroups $columns="2fr 1fr">
            <div>
              {/*<section>
                <h5>Qual o nome do seu Criativo?</h5>
              </section> */}
              <Input
                name="nomeproduto"
                placeholder="Nome do produto"
                disabled={loadingURL}
              />
            </div>
            <div>
              {/* <section>
                <h5>Qual a duração?</h5>
              </section> */}
              <Radio
                name="duracao"
                disabled={loadingURL}
                options={[
                  { id: '5', label: '5s' },
                  { id: '10', label: '10s' },
                  { id: '15', label: '15s' },
                ]}
              />
            </div>
          </FormGroups>
        </StepSection>
        <StepSection>
          <div>
            <header>
              <h5>QUAL O OBJETIVO</h5>
              <p>Qual o objetivo do seu criativo?</p>
            </header>
          </div>
          <FormGroups $columns="2fr">
            <div>
              <Select
                {...selectMenuProps}
                name="objetivos"
                options={objetivos || []}
                placeholder="Objetivo"
                isSearchable
                fill={false}
                disabled={loadingURL}
              />
            </div>
          </FormGroups>
        </StepSection>
        <StepSection>
          <div>
            <header>
              <h5>ENVIE AS IMAGENS DO SEU CLIENTE</h5>
              <p>
                Envie a logo e, se desejar, uma imagem adicional para o seu
                criativo.
              </p>
            </header>
          </div>
          <ImagensContainer>
            <ImagemItem>
              <div>
                <section>
                  <h4>LOGO </h4>
                </section>
                <ReactDropzoneInput name="file_0" disabled={loadingURL} />
                <input type="hidden" name="tipo_0" value="logo" />
              </div>
            </ImagemItem>
            <ImagemItem>
              <div>
                <section>
                  <h4>IMAGEM OPCIONAL 1</h4>
                </section>
                <ReactDropzoneInput name="file_1" disabled={loadingURL} />
                <Select
                  {...selectMenuProps}
                  name="tipo_1"
                  options={options?.imagens || []}
                  placeholder="Tipo da imagem"
                  isSearchable
                  disabled={loadingURL}
                  fill={false}
                />
              </div>
            </ImagemItem>
            <ImagemItem>
              <div>
                <section>
                  <h4>IMAGEM OPCIONAL 2</h4>
                </section>
                <ReactDropzoneInput name="file_2" disabled={loadingURL} />
                <Select
                  {...selectMenuProps}
                  name="tipo_2"
                  options={options?.imagens || []}
                  placeholder="Tipo da imagem"
                  isSearchable
                  disabled={loadingURL}
                  fill={false}
                />
              </div>
            </ImagemItem>
            <ImagemItem>
              <div>
                <section>
                  <h4>IMAGEM OPCIONAL 3</h4>
                </section>
                <ReactDropzoneInput name="file_3" disabled={loadingURL} />
                <Select
                  {...selectMenuProps}
                  name="tipo_3"
                  options={options?.imagens || []}
                  placeholder="Tipo da imagem"
                  isSearchable
                  disabled={loadingURL}
                  fill={false}
                />
              </div>
            </ImagemItem>
          </ImagensContainer>
        </StepSection>
      </div>
    );
  }
  function renderStep2() {
    return (
      <div>
        <StepSection>
          <div>
            <header>
              <h5>TIPO DE NÉGOCIO</h5>
              <p>Qual a categorias do seu negócio?</p>
            </header>
          </div>
          <div>
            <Select
              {...selectMenuProps}
              name="categorias"
              options={categoriasOptions}
              placeholder="Categoria"
              isSearchable
              fill={false}
              onChange={(value: any) => {
                handleCategoriaChange(value);
              }}
            />
          </div>
        </StepSection>
        <StepSection>
          <div>
            <header>
              <h5>QUAL O SEGMENTO</h5>
              <p>Qual o segmento do seu negócio?</p>
            </header>
          </div>
          <div>
            <Select
              {...selectMenuProps}
              name="segmentos"
              options={segmentos}
              placeholder="Segmento"
              isSearchable
              fill={false}
            />
          </div>
        </StepSection>
        <StepSection>
          <div>
            <header>
              <h5>MODELO DO CRIATIVO</h5>
              <p>Escolha qual o foco que seu vídeo deve possuir.</p>
            </header>
          </div>
          <OptionCard>
            <Radio
              name="tipo"
              options={[
                {
                  id: 'produto',
                  label: 'PRODUTO',
                },
                {
                  id: 'institucional',
                  label: 'INSTITUCIONAL',
                },
              ]}
              handleSelected={option => {
                setTipoSelecionado(option.id);
                formDataRef.current = {
                  ...formDataRef.current,
                  tipo: option.id,
                };
              }}
              direction="row"
            />
          </OptionCard>
        </StepSection>
      </div>
    );
  }
  function renderStep3() {
    return (
      <div className="step-content">
        <StepSection>
          <div>
            <header>
              <h5>CALL TO ACTION</h5>
              <p>
                Adicione informações extras, locução ou textos ao seu vídeo, se
                desejar.
              </p>
            </header>
          </div>
          <CallToActionFields>
            {/* <Select
              {...selectMenuProps}
              name="estilo_1"
              placeholder="Estilo de texto"
              options={options?.textos?.estilo || []}
            /> */}
            <TextArea
              name="conteudo_1"
              height={100}
              placeholder="O que deve ter nesse texto?"
            />
          </CallToActionFields>
        </StepSection>
        <StepSection>
          <div>
            <header>
              <h5>RECURSOS OPCIONAIS</h5>
              <p>
                Adicione informações extras, locução ou textos ao seu vídeo, se
                desejar.
              </p>
            </header>
          </div>
          <OptionalContent>
            <Checkbox
              name="habilitarLocucao"
              options={[
                {
                  id: 'locucao',
                  label: 'Deseja adicionar locução?',
                },
              ]}
              columns="1fr"
              handleSelected={({ checked }) => {
                const value = Boolean(checked);
                setMostrarLocucao(value);
                formDataRef.current = {
                  ...formDataRef.current,
                  habilitarLocucao: value,
                };
              }}
            />

            {mostrarLocucao && (
              <div className="optional-block">
                <VoiceGrid>
                  <div className="voice-options">
                    <Select
                      {...selectMenuProps}
                      name="locucaogenero"
                      options={options?.locucao?.locucaogenero || []}
                      placeholder="Gênero da locução"
                      isSearchable
                      fill={false}
                    />
                    <Select
                      {...selectMenuProps}
                      name="locucaoidade"
                      options={options?.locucao?.locucaoidade || []}
                      placeholder="Idade da locução"
                      isSearchable
                      fill={false}
                    />
                    <Select
                      {...selectMenuProps}
                      name="locucaotom"
                      options={options?.locucao?.locucaotom || []}
                      placeholder="Tom da locução"
                      isSearchable
                      fill={false}
                    />
                  </div>
                  <div className="voice-texts">
                    <TextArea
                      name="locucaotexto_0"
                      height={100}
                      placeholder="Digite as falas"
                    />
                    <TextArea
                      name="locucaotexto_1"
                      height={100}
                      placeholder="Digite as falas (Opcional)"
                    />
                    <TextArea
                      name="locucaotexto_2"
                      height={100}
                      placeholder="Digite as falas (Opcional)"
                    />
                  </div>
                </VoiceGrid>
              </div>
            )}

            <div className="optional-texts">
              <Checkbox
                name="habilitarTextos"
                options={[
                  {
                    id: 'textos',
                    label: 'Deseja adicionar um texto extra durante o vídeo?',
                  },
                ]}
                columns="1fr"
                handleSelected={({ checked }) => {
                  const value = Boolean(checked);
                  setMostrarTextos(value);
                  formDataRef.current = {
                    ...formDataRef.current,
                    habilitarTextos: value,
                  };
                }}
              />
              {mostrarTextos && (
                <div className="optional-block">
                  <TextGrid>
                    <div className="text-item">
                      <Select
                        {...selectMenuProps}
                        name="estilo_0"
                        placeholder="Estilo de texto"
                        options={options?.textos?.estilo || []}
                      />
                      <Select
                        {...selectMenuProps}
                        name="momento_0"
                        placeholder="Em qual momento deve aparecer?"
                        options={options?.textos?.momento || []}
                      />
                      <Select
                        {...selectMenuProps}
                        name="posicao_0"
                        placeholder="Onde deve aparecer?"
                        options={options?.textos?.posicao || []}
                      />
                      <TextArea
                        name="conteudo_0"
                        height={100}
                        placeholder="O que deve ter nesse texto?"
                      />
                    </div>
                  </TextGrid>
                </div>
              )}
            </div>
          </OptionalContent>
        </StepSection>
      </div>
    );
  }

  const renderSite = useCallback(
    () => (
      <Form
        ref={formRefSite}
        onSubmit={handleSubmitSite}
        initialData={initialData}
      >
        <div className="step-content">
          <StepSection>
            <div>
              <header>
                <h5>INFORMAÇÕES BÁSICAS</h5>
                <p>Defina o nome e a duração do seu criativo.</p>
              </header>
            </div>
            <FormGroups $columns="2fr 1fr">
              <div>
                {/*<section>
                <h5>Qual o nome do seu Criativo?</h5>
              </section> */}
                <Input
                  name="nomeproduto"
                  placeholder="Nome do produto"
                  disabled={loadingURL}
                />
              </div>
              <div>
                {/* <section>
                <h5>Qual a duração?</h5>
              </section> */}
                <Radio
                  name="duracao"
                  disabled={loadingURL}
                  options={[
                    { id: '5', label: '5s' },
                    { id: '10', label: '10s' },
                    { id: '15', label: '15s' },
                  ]}
                />
              </div>
            </FormGroups>
          </StepSection>
          <StepSection>
            <div>
              <header>
                <h5>QUAL O OBJETIVO</h5>
                <p>Qual o objetivo do seu criativo?</p>
              </header>
            </div>
            <FormGroups $columns="2fr">
              <div>
                <Select
                  {...selectMenuProps}
                  name="objetivos"
                  options={objetivos || []}
                  placeholder="Objetivo"
                  isSearchable
                  fill={false}
                  disabled={loadingURL}
                />
              </div>
            </FormGroups>
          </StepSection>
          <StepSection>
            <div>
              <header>
                <h5>SEU CLIENTE POSSUI SITE?</h5>
                <p>Insira a URL abaixo e vamos buscar as informações.</p>
              </header>
            </div>
            <div>
              <Input
                name="site"
                placeholder="Insira o site, exemplo: http://www.rpc.com.br"
                disabled={loadingURL || loadingSubmit}
              />
            </div>
          </StepSection>
        </div>
      </Form>
    ),
    [
      handleSubmitSite,
      initialData,
      selectMenuProps,
      objetivos,
      loadingURL,
      loadingSubmit,
    ],
  );

  const formRevisao = useCallback(() => {
    const midias = Array.isArray(initialData.criativomidias)
      ? initialData.criativomidias
      : [];
    return (
      <ScrollArea>
        <Form ref={formRef} onSubmit={handleSubmit} initialData={initialData}>
          <StepHeader>
            <div>
              <header>
                <h5>REVISE AS INFORMAÇÕES</h5>
                <p>
                  Confira as informações abaixo antes de aceitar ou recusar o
                  criativo.
                </p>
              </header>
            </div>
          </StepHeader>

          <FormGroups $columns="1fr 1fr">
            <StepSection>
              <OptionCard>
                <EditableField
                  label="NOME DO PRODUTO"
                  value={
                    formDataRef.current.nomeproduto
                      ? `${formDataRef.current.nomeproduto}`
                      : 'Informação Obrigatória'
                  }
                >
                  <Input name="nomeproduto" placeholder="Nome do produto" />
                </EditableField>
              </OptionCard>
            </StepSection>
            <StepSection>
              <OptionCard>
                <EditableField
                  label="DURAÇÃO"
                  value={
                    formDataRef.current.duracao
                      ? `${formDataRef.current.duracao}s`
                      : 'Informação Obrigatória'
                  }
                >
                  <Radio
                    name="duracao"
                    options={[
                      { id: '5', label: '5s' },
                      { id: '10', label: '10s' },
                      { id: '15', label: '15s' },
                    ]}
                    handleSelected={(option: any) => {
                      const valor = String(option.id);
                      formDataRef.current = {
                        ...formDataRef.current,

                        duracao: valor,
                      };
                      formRef.current?.setFieldValue('duracao', valor);
                    }}
                    direction="row"
                  />
                </EditableField>
              </OptionCard>
            </StepSection>
          </FormGroups>
          {midias && (
            <StepSection>
              <div>
                <header>
                  <h5>IMAGENS DO CRIATIVO</h5>
                  <p>Imagens utilizadas no criativo original.</p>
                </header>
              </div>
              <ImagensContainer>
                {midias.map((midia, index) => (
                  <ImagemItem key={midia.id ?? index}>
                    {console.log(midia.download_url)}

                    <img
                      src={midia.download_url ?? ''}
                      alt={`Imagem ${index + 1} do criativo`}
                      style={{
                        display: 'block',
                        width: '100%',
                        maxHeight: 220,
                        objectFit: 'contain',
                        borderRadius: 8,
                      }}
                    />
                  </ImagemItem>
                ))}
              </ImagensContainer>
            </StepSection>
          )}
          <StepSection>
            <FormGroups $columns="1fr 1fr 1fr">
              <OptionCard>
                <EditableField
                  label="CATEGORIAS"
                  value={categorias?.rotulo ?? 'Informação Obrigatória'}
                >
                  <Select
                    {...selectMenuProps}
                    name="categorias"
                    options={categoriasOptions}
                    placeholder="Categoria"
                    isSearchable
                    fill={false}
                    onChange={(value: any) => {
                      updateFormField('categorias', value);
                      handleCategoriaChange(value);
                    }}
                  />
                </EditableField>
              </OptionCard>
              <OptionCard>
                <EditableField
                  label="SEGMENTO"
                  value={segmento ?? 'Informação Obrigatória'}
                >
                  <Select
                    {...selectMenuProps}
                    name="segmentos"
                    options={segmentos}
                    placeholder="Segmento"
                    isSearchable
                    fill={false}
                    onChange={(value: any) => {
                      updateFormField('segmentos', value);
                    }}
                  />
                </EditableField>
              </OptionCard>
              <OptionCard>
                <EditableField
                  label="OBJETIVO"
                  value={objetivo?.rotulo ?? 'Informação Obrigatória'}
                >
                  <Select
                    {...selectMenuProps}
                    name="objetivos"
                    options={objetivos}
                    placeholder="Objetivo"
                    isSearchable
                    fill={false}
                    onChange={(value: any) => {
                      updateFormField('objetivos', value);
                    }}
                  />
                </EditableField>
              </OptionCard>
            </FormGroups>
          </StepSection>

          <StepSection>
            <div>
              <header>
                <h5>CALL TO ACTION</h5>
                <p>
                  Altere o texto de chamada para ação independentemente do texto
                  extra.
                </p>
              </header>
            </div>
            <div>
              <OptionCard>
                <EditableField
                  label="CONTEÚDO"
                  value={
                    formDataRef.current?.conteudo_1 || 'Informação Obrigatória'
                  }
                >
                  <TextArea
                    name="conteudo_1"
                    height={100}
                    placeholder="Texto"
                    defaultValue={
                      formDataRef.current?.conteudo_1 ??
                      'Informação Obrigatória'
                    }
                  />
                </EditableField>
              </OptionCard>
            </div>
          </StepSection>
          <StepSection>
            <div>
              <header>
                <h5>TEXTO EXTRA</h5>
                <p>
                  Altere o texto de chamada para ação independentemente do texto
                  extra.
                </p>
              </header>
            </div>
            <div>
              <OptionCard>
                <EditableField
                  label="CONTEÚDO"
                  value={formDataRef.current?.conteudo_0 || 'NA'}
                >
                  <TextArea
                    name="conteudo_0"
                    height={100}
                    placeholder="Texto"
                    defaultValue={formDataRef.current?.conteudo_0 ?? 'NA'}
                  />
                </EditableField>
              </OptionCard>
            </div>
          </StepSection>
          <StepSection>
            <div>
              <header>
                <h5>LOCUÇÃO</h5>
                <p>Altere as configurações da locução somente se necessário.</p>
              </header>
            </div>
            <FormGroups $columns="1fr 1fr 1fr">
              <StepSection>
                <OptionCard>
                  <EditableField
                    label="GÊNERO"
                    value={
                      options?.locucao?.locucaogenero?.find(
                        (item: OpcaoSelect) =>
                          item.value === formDataRef.current?.locucaogenero,
                      )?.label ?? 'NA'
                    }
                  >
                    <Select
                      {...selectMenuProps}
                      name="locucaogenero"
                      options={options?.locucao?.locucaogenero || []}
                      placeholder="Gênero"
                      isSearchable
                      fill={false}
                      onChange={(value: OpcaoSelect | null) => {
                        updateFormField('locucaogenero', value?.value ?? 'NA');
                      }}
                    />
                  </EditableField>
                </OptionCard>
              </StepSection>
              <StepSection>
                <OptionCard>
                  <EditableField
                    label="IDADE"
                    value={
                      options?.locucao?.locucaoidade?.find(
                        (item: OpcaoSelect) =>
                          item.value === formDataRef.current?.locucaoidade,
                      )?.label ?? 'NA'
                    }
                  >
                    <Select
                      {...selectMenuProps}
                      name="locucaoidade"
                      options={options?.locucao?.locucaoidade || []}
                      placeholder="Idade"
                      isSearchable
                      fill={false}
                      onChange={(value: OpcaoSelect | null) => {
                        updateFormField('locucaoidade', value?.value ?? 'NA');
                      }}
                    />
                  </EditableField>
                </OptionCard>
              </StepSection>
              <StepSection>
                <OptionCard>
                  <EditableField
                    label="TOM"
                    value={
                      options?.locucao?.locucaotom?.find(
                        (item: OpcaoSelect) =>
                          item.value === formDataRef.current?.locucaotom,
                      )?.label ?? 'NA'
                    }
                  >
                    <Select
                      {...selectMenuProps}
                      name="locucaotom"
                      options={options?.locucao?.locucaotom || []}
                      placeholder="Tom"
                      isSearchable
                      fill={false}
                      onChange={(value: OpcaoSelect | null) => {
                        updateFormField('locucaotom', value?.value ?? 'NA');
                      }}
                    />
                  </EditableField>
                </OptionCard>
              </StepSection>
            </FormGroups>
            <StepSection>
              <div>
                <header>
                  {/* <h5>FALAS</h5> */}
                  <p>Adicione de 1 a 3 falas para a locução.</p>

                  {quantidadeFalas < 3 && (
                    <Button
                      type="button"
                      fill
                      color="font"
                      round
                      onClick={adicionarFala}
                    >
                      <FiPlus />
                    </Button>
                  )}
                </header>
                <FalasGrid>
                  {Array.from({ length: quantidadeFalas }, (_, index) => {
                    const field = `locucaotexto_${index}`;
                    const texto = formDataRef.current?.[field];
                    return (
                      <OptionCard key={field}>
                        <OptionCardHeader>
                          {quantidadeFalas > 1 && (
                            <OptionCardActions>
                              <Button
                                type="button"
                                fill
                                title="Remover fala"
                                onClick={() => removerFala(index)}
                                color="font"
                                round
                              >
                                <FiX />
                              </Button>
                            </OptionCardActions>
                          )}
                        </OptionCardHeader>
                        <EditableField
                          label={`FALA ${index + 1}`}
                          value={texto || '-'}
                        >
                          <TextArea
                            name={field}
                            height={100}
                            placeholder={
                              index === 0
                                ? 'Digite a fala'
                                : 'Digite a fala (Opcional)'
                            }
                            defaultValue={texto ?? ''}
                          />
                        </EditableField>
                      </OptionCard>
                    );
                  })}
                </FalasGrid>
              </div>
            </StepSection>
          </StepSection>
          {modoRefinamento && (
            <StepSection>
              <div>
                <header>
                  <h5>DESEJA ALTERAR ALGO EM ESPECÍFICO? </h5>
                  <p>
                    Escreva de forma direta o que deseja alterar no criativo
                    gerado. Exemplo: alterar camisa para moletom. Retirar porta
                    ao fundo.
                  </p>
                </header>
              </div>
              <TextArea
                name="detalhes_en"
                height={100}
                placeholder="detalhes_en"
              />
            </StepSection>
          )}
        </Form>
      </ScrollArea>
    );
  }, [
    adicionarFala,
    categorias?.rotulo,
    categoriasOptions,
    handleCategoriaChange,
    handleSubmit,
    initialData,
    modoRefinamento,
    objetivo?.rotulo,
    objetivos,
    options?.locucao?.locucaogenero,
    options?.locucao?.locucaoidade,
    options?.locucao?.locucaotom,
    quantidadeFalas,
    removerFala,
    segmento,
    segmentos,
    selectMenuProps,
    updateFormField,
  ]);

  function RedirectFormulario() {
    return (
      <ScrollArea>
        <Form ref={formRef} onSubmit={handleSubmit} initialData={initialData}>
          <StepHeader>
            <h4>
              {modoRefinamento ? 'REFINAR CRIATIVO' : `ETAPA ${step} DE 4`}
            </h4>
          </StepHeader>

          <ScrollContent>
            {modoRefinamento ? (
              <div>{formRevisao()}</div>
            ) : (
              <>
                <div style={{ display: step === 1 ? 'block' : 'none' }}>
                  {renderStep1()}
                </div>
                <div style={{ display: step === 2 ? 'block' : 'none' }}>
                  {renderStep2()}
                </div>
                <div style={{ display: step === 3 ? 'block' : 'none' }}>
                  {renderStep3()}
                </div>
                <div style={{ display: step === 4 ? 'block' : 'none' }}>
                  {formRevisao()}
                </div>
              </>
            )}
          </ScrollContent>
        </Form>
      </ScrollArea>
    );
  }

  function FormularioSite() {
    return (
      <ScrollArea>
        <StepHeader>
          <h4>CRIAR CRIATIVO POR SITE</h4>
        </StepHeader>

        <ScrollContent>{renderSite()}</ScrollContent>
      </ScrollArea>
    );
  }

  return createPortal(
    <Overlay>
      <ModalContainer width="1200px">
        <ModalContent>
          {loading
            ? 'Loading'
            : modoRefinamento
            ? formRevisao()
            : tipoFormulario === 'site'
            ? FormularioSite()
            : RedirectFormulario()}
        </ModalContent>

        <ModalFooter>
          <Actions>
            <ActionsLeft>
              {!modoRefinamento && tipoFormulario === 'normal' && step > 1 && (
                <Button
                  type="button"
                  color="default"
                  onClick={() => changeStep(step - 1)}
                >
                  <FiChevronLeft />
                  ANTERIOR
                </Button>
              )}
            </ActionsLeft>

            <ActionsCenter>
              <Button
                type="button"
                color="default"
                onClick={() => setShowCriativoModal(false)}
              >
                CANCELAR
              </Button>
            </ActionsCenter>

            <ActionsRight>
              {tipoFormulario === 'site' || modoRefinamento || step === 4 ? (
                <Button
                  type="button"
                  color="primary"
                  disabled={loadingSubmit || loadingURL}
                  onClick={() => {
                    if (tipoFormulario === 'site') {
                      formRefSite.current?.submitForm();
                      return;
                    }

                    formRef.current?.submitForm();
                  }}
                >
                  {tipoFormulario === 'site' ? <FiSearch /> : <FiSave />}

                  {loadingSubmit || loadingURL ? (
                    <Spinner type="ThreeDots" />
                  ) : tipoFormulario === 'site' ? (
                    'BUSCAR'
                  ) : (
                    'CRIAR'
                  )}
                </Button>
              ) : tipoFormulario === 'normal' ? (
                <Button
                  type="button"
                  color="primary"
                  disabled={loadingURL}
                  onClick={e => {
                    e.preventDefault();
                    void changeStep(step + 1);
                  }}
                >
                  PRÓXIMO
                  <FiChevronRight />
                </Button>
              ) : null}
            </ActionsRight>
          </Actions>
        </ModalFooter>
      </ModalContainer>
    </Overlay>,
    document.body,
  );
}
